import { fetchJson } from '../../apiBase';

async function request(path, options) {
  const response = await fetchJson(path, options);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(typeof payload.detail === 'string' ? payload.detail : 'Çark bilgileri alınamadı.');
    error.status = response.status;
    throw error;
  }
  return payload;
}

const classPath = (schoolId, classId) => `/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/wheel`;
export const fetchWheel = (token) => request(`/mini-tasks/board/${encodeURIComponent(token)}/wheel`);
export const fetchClassroomBalloon = (token) => request(`/mini-tasks/board/${encodeURIComponent(token)}/balloon`);
export const fetchWheelSettings = (schoolId, classId) => request(classPath(schoolId, classId));
export const fetchWheelPool = (schoolId, classId) => request(`${classPath(schoolId, classId)}/pool`);
export const saveWheelSettings = (schoolId, classId, body) => request(classPath(schoolId, classId), {
  method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
});
export const previewWheel = (schoolId, classId, includeDrafts) => request(`${classPath(schoolId, classId)}/preview`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ includeDrafts }),
});
